import { AxiosPromise } from 'axios';
import { instance } from '../../../services';

const attemptGustLogin = (pin: string): AxiosPromise =>
  instance.post('api/accounts/guest', { pin });

export default attemptGustLogin;
